module.exports = __webpack_public_path__ + "static/assets/5db0bb567f5070be1b4bd63dde3fbe92.svg";